import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'rd-button',
  template: `<button class="rdButton {{color}}Button" [class.rounded]="rounded" (click)="buttonClick.emit($event)">
  <ng-content></ng-content>
</button>
`,
  styles: [`.rdButton{--main-color:#ba9e5a;border:none;box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);width:100%;padding:6px;text-align:center;color:#fff;cursor:pointer;transition:all .1s ease-in-out,background .6s ease-in-out;background:var(--main-color) center}.rdButton:hover{-webkit-transform:translateY(-3px);transform:translateY(-3px);box-shadow:0 8px 17px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19)}.rdButton:active{-webkit-transform:translateY(3px);transform:translateY(3px)}.rdButton.rounded{border-radius:15px/50%}.blueButton{--main-color:#5a5aba}.gradient-blueButton{--main-color:linear-gradient(45deg, #5aa2ba, #5a5aba)}.gradient-peachButton{--main-color:linear-gradient(45deg, #ba8a5a 20%, #ba5a5a 80%)}.greenButton{--main-color:#72ba5a}.blue-lightButton{--main-color:#5aa2ba}.redButton{--main-color:#ba5a5a}.purpleButton{--main-color:#a25aba}.orangeButton{--main-color:#ba8a5a}`]
})
export class RDButtonComponent implements OnInit {

  @Input() color = 'gold';
  @Input() rounded = false;

  @Output() buttonClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
